import React, { useEffect, useState } from 'react';
import { getInspections } from '../services/api';

function InspectionHistory({ mode, refreshKey }) {
  const [inspections, setInspections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    getInspections(10, mode)
      .then(data => {
        if (!cancelled) setInspections(data);
      })
      .catch(() => {
        if (!cancelled) setInspections([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [mode, refreshKey]);

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-US', {
      month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  const getScoreClass = (score) => {
    if (score >= 80) return 'score-good';
    if (score >= 50) return 'score-warning';
    return 'score-critical';
  };

  return (
    <div className="inspection-history card">
      <h3 className="card-title">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
          <path d="M9 1C4.6 1 1 4.6 1 9s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14.4A6.4 6.4 0 1115.4 9 6.41 6.41 0 019 15.4zM9.4 5H8v5l4.4 2.6.6-1-3.6-2.1V5z"/>
        </svg>
        Inspection History
      </h3>

      {loading ? (
        <div className="history-loading">
          {[1, 2, 3].map(i => (
            <div key={i} className="shimmer-line"></div>
          ))}
        </div>
      ) : inspections.length === 0 ? (
        <div className="history-empty">
          <p>No inspections yet. Upload an image to start.</p>
        </div>
      ) : (
        <div className="history-table-wrapper">
          <table className="history-table">
            <thead>
              <tr>
                <th>File</th>
                <th>Score</th>
                <th>Persons</th>
                <th>Violations</th>
                <th>Alerts</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {inspections.map((insp) => (
                <tr key={insp.inspectionId || insp._id}>
                  <td className="file-cell" title={insp.fileName}>
                    {insp.fileName?.length > 25
                      ? insp.fileName.slice(0, 22) + '...'
                      : insp.fileName}
                  </td>
                  <td>
                    <span className={`score-badge ${getScoreClass(insp.complianceScore)}`}>
                      {insp.complianceScore}%
                    </span>
                  </td>
                  <td>{insp.summary?.totalPersons || 0}</td>
                  <td>
                    {insp.summary?.violations > 0 ? (
                      <span className="violation-count">{insp.summary.violations}</span>
                    ) : (
                      <span className="no-violations">0</span>
                    )}
                  </td>
                  <td>{insp.alerts?.length || 0}</td>
                  <td className="time-cell">{formatDate(insp.timestamp)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default InspectionHistory;
